import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadOkrMetricById,
    setOkrMetricEdit,
    setOkrMetricReloadEdit,
    initOkrMetric,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface OkrMetricEditProps {
    metricId: number
    onCreate?: (newMetricId: number) => void
}

const Edit = ({
    metricId,
    onCreate = null,
}: OkrMetricEditProps) => {
    const metric = useSelector((state: StoreType) => state.okrMetric.metricEdit)
    const reloadEdit = useSelector((state: StoreType) => state.okrMetric.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setOkrMetricReloadEdit(false))
        setTimeout(() => {
            dispatch(setOkrMetricReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (metricId === 0) {
            dispatch(setOkrMetricEdit(initOkrMetric))
            reload()
        } else {
            setLoadState(PENDING)
            LoadOkrMetricById(metricId, userData.accountId).then((res) => {
                dispatch(setOkrMetricEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!metric) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{metric.id ? `${lang.editMetric} #${metric.id}` : lang.addMetric}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form metric={metric} onCreate={onCreate} />
                }
                {
                    reloadEdit
                    && <Form metric={metric} onCreate={onCreate} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
